import axiosInstance from './axiosInstance';

export async function searchJobs(filters) {
  const response = await axiosInstance.post('/jobs/search', filters);
  return response.data;
}

export async function loadMoreJobs(cursor) {
  const response = await axiosInstance.post('/jobs/search/more', { cursor });
  return response.data;
}

export async function saveJobs(jobs, searchLocationFilter, searchIndustryFilter) {
  const response = await axiosInstance.post('/jobs/save', {
    jobs,
    searchLocationFilter,
    industry: searchIndustryFilter,
  });
  return response.data;
}

export async function fetchSavedJobs(page = 1, pageSize = 10, filters = {}) {
  // Strip empty values so we don't send e.g. jobTitle='' as a real filter param.
  const params = { page, pageSize };
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== '' && value !== null && value !== undefined) params[key] = value;
  });

  const response = await axiosInstance.get('/jobs/database', { params });
  return response.data;
}